<template>
    <ValidationObserver
        ref="newFavorite"
        v-slot="{ passes }"
    >
        <BaseDialog
            :showDialog="showDialog"
            headline="lang_LABEL_STATISTIC_ADD_NEW_FILTER"
            :close="closeDialog"
        >
            <template v-slot:dialogText>
                <v-container fluid>
                    <v-row>
                        <v-col>
                            <BaseEditPageTextField
                                context="PublishingStatisticsCreateNewFavoriteDialog"
                                field="FavoriteName"
                                :label="$t('lang_LABEL_STATISTIC_CAPTION_FAVORITE_NAME')"
                                rules="required|statisticsFavoriteNameUnique:getPublishingStatisticsFavoriteDropdownValues"
                                :withMargin="false"
                                noDataText="lang_LABEL_STATISTIC_NO_FILTER"
                                :alvqa="alvqa + '-textfield-favorit-name'"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </template>
            <template v-slot:dialogActions>
                <v-container fluid>
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col class="text-right">
                            <BaseButton
                                @click="passes(saveFavorite)"
                                label="lang_LABEL_STATISTIC_ADD_NEW_FILTER"
                                :alvqa="alvqa + '-button-add'"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </template>
        </BaseDialog>
    </ValidationObserver>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'

export default {
    name: 'PublishingStatisticsCreateNewFavoriteDialog',
    components: {
        BaseDialog,
        BaseButton,
        BaseEditPageTextField,
    },
    data() {
        return {
            alvqa: 'publishing-statistics-create-new-favorite-dialog',
        }
    },
    computed: {
        showDialog: {
            get() { return this.$store.getters.getShowPublishingStatisticsCreateNewFavoriteDialog },
            set(value) { this.$store.commit('setShowPublishingStatisticsCreateNewFavoriteDialog', value) },
        },
        favoritName: {
            get() { return this.$store.getters.getPublishingStatisticsCreateNewFavoriteDialogDetailsFavoriteName },
            set(value) { this.$store.commit('setPublishingStatisticsCreateNewFavoriteDialogDetailsFavoriteName', value) },
        },
    },
    methods: {
        closeDialog() {
            this.showDialog = false
            this.favoritName = null
            this.$store.commit('setSelectedPublishingStatisticsFavorite', null)
            this.$store.dispatch('fetchPublishingStatisticsFavoriteDropdownValues')
            this.$refs.newFavorite.reset()
        },
        async saveFavorite() {
            const saved = await this.$store.dispatch('saveNewPublishingStatisticsFavorite')
            if (!saved) return
            this.$store.commit('setShowPublishingStatisticsCreateNewFavoriteDialog', false)
            this.closeDialog()
        },
    },
}
</script>
